// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiRequest } from '../_helpers/apiConfig'



//// admin login history==>>>>>>>>>>>>>
export const getICOList = createAsyncThunk(
    'ico/getICOList',
    async filters => {
        const response = await apiRequest(
            'POST',
            '/v1/ico/getICOList',
            filters
        )
        return response
    }
)

export const updateIco = createAsyncThunk(
    'ico/updateIco',
    async filters => {
        const response = await apiRequest(
            'POST',
            '/v1/ico/updateIco',
            filters
        )
        return response
    }
)

/// user management apis->>>>>>>>>>>

const icoSlice = createSlice({
    name: 'ico',
    initialState: {
        icoListData: {},
        category: [],
        total: null,
        loading: false,
        error: null
    },
    reducers: {
    },
    extraReducers: builder => {
        builder
            .addCase(getICOList.pending, state => {
                state.loading = true
                state.error = null
            })
            .addCase(getICOList.fulfilled, (state, action) => {
                state.loading = false
                state.icoListData = action.payload.data
            })
            .addCase(getICOList.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            .addCase(updateIco.pending, state => {
                state.loading = true
                state.error = null
            })
            .addCase(updateIco.fulfilled, (state, action) => {
                state.loading = false
                state.icoListData = action.payload.data
            })
            .addCase(updateIco.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })

    }
})

// Export the actions and reduce
export default icoSlice.reducer
